// extracted by mini-css-extract-plugin
export default {"base":"vp_OUlJP","label":"vp_kYUgm","content":"vp_Sh4rX","logo":"vp_RLSzX","dots":"vp_TQgTV","dot":"vp_X00OS","pulse":"vp_LL_c_"};